<template>
  <div class="hm-dashboard__line">
    <div class="hm-dashboard__line-left">
      <div class="hm-dashboard__grid">
        <div>
          <router-link
            :to="{ name: 'hotel-management-reservations-detail-rooms-detail', params: { id: room.reservation.id, roomId: room.id } }"
            class="hm-dashboard__grid-name hm-dashboard__highlighted"
          >
            {{ room.reservation.group_name }}
          </router-link>
        </div>
        <div class="hm-dashboard__grid-holder">
          <span class="hm-dashboard__grid-number hm-dashboard__highlighted">
            <template v-if="room.room">{{ room.room.short_name }}</template>
            <img v-else src="@/assets/img/hm/warning.svg" alt="">
          </span>
          <span class="hm-dashboard__grid-number">{{ room.short_room.room_category.name }}</span>
<!--          <span class="hm-dashboard__grid-room hm-dashboard__grid-room&#45;&#45;dirty">-->
<!--              <DirtyIcon aria-hidden="true"/>-->
<!--              <span>Dirty</span>-->
<!--          </span>-->
        </div>
        <div class="hm-dashboard__dates">
          <CalendarIcon aria-hidden="true"/>
          <span>{{ fmtShortDate(room.short_room.check_in) }}</span>
          <ArrowIcon aria-hidden="true"/>
          <span>{{ fmtShortDate(room.short_room.check_out) }}</span>
        </div>
        <div class="hm-dashboard__content-guest">
              <span class="hm-dashboard__gender">
                <MaleIcon v-if="room.guests[0]?.gender && room.guests[0]?.gender.code === 'male'"/>
                <FemaleIcon v-else-if="room.guests[0]?.gender && room.guests[0]?.gender.code === 'female'"/>
              </span>
          <span
            v-if="room.guests[0]"
            :class="{ 'hm-dashboard__flag--empty': !(room.guests[0]?.citizenship && room.guests[0]?.citizenship.code) }"
            :title="room.guests[0]?.citizenship && room.guests[0]?.citizenship.name ? room.guests[0]?.citizenship.name : ''"
            class="hm-dashboard__flag"
          >
                <span
                  v-if="room.guests[0]?.citizenship && room.guests[0]?.citizenship.code"
                  :class="`fflag ff-md fflag-${room.guests[0]?.citizenship.code}`"
                ></span>
              </span>
          <button v-else class="hm-dashboard__add-guest">
            <PlusSmallGreen/>
          </button>
          <span :class="{'hm-dashboard__guest-name--unknown': !room.guests[0]}" class="hm-dashboard__guest-name">
                <span v-if="room.guests[0]" class="hm-dashboard__highlighted">
                  {{
                    (
                      room.guests[0]?.gender && room.guests[0]?.gender.greeting
                    ) ? room.guests[0]?.gender.greeting : ''
                  }} {{
                    room.guests[0]?.full_name || (
                      (
                        room.guests[0]?.first_name || ''
                      ) + ' ' + (
                        room.guests[0]?.last_name || ''
                      )
                    )
                  }}
                </span>
                <span v-else>Guest #1 - Unknown</span>
              </span>
        </div>
      </div>
      <div class="hm-dashboard__grid">
        <div class="hm-dashboard__grid-holder" style="gap: 10px">
          <span class="hm-dashboard__grid-info">
            {{ room.reservation.source.name }} <template v-if="room.reservation.external_id">({{ room.reservation.external_id }})</template>
          </span>
        </div>
        <div class="hm-dashboard__grid-holder hm-dashboard__grid-holder--between">
          <span class="hm-dashboard__grid-info">Balance:</span>
          <HMBalance :balance="room.balance" />
        </div>
        <HMChipList>
          <HMChip>
            {{ room.short_room.nights || '0' }}
            <template #icon><NightsIcon aria-hidden="true" /></template>
          </HMChip>
          <HMChip
            v-if="room.reservation?.meal_plan?.name"
            :title="room.reservation.meal_plan.full_name"
            :color="room.reservation.meal_plan.color"
            isMeal
          >
            {{ room.reservation.meal_plan.name }}
          </HMChip>
          <HMChip v-if="room.short_room.accomodation_type?.age_assignment?.adult" color="#9AB992">
            {{ room.short_room.accomodation_type.age_assignment.adult }}
            <template #icon><AdultIcon aria-hidden="true" /></template>
          </HMChip>
          <HMChip v-if="room.short_room.accomodation_type?.age_assignment?.teenager" color="#76A9B4">
            {{ room.short_room.accomodation_type.age_assignment.teenager }}
            <template #icon><TeenagerIcon aria-hidden="true" /></template>
          </HMChip>
          <HMChip v-if="room.short_room.accomodation_type?.age_assignment?.child" color="#D493B0">
            {{ room.short_room.accomodation_type.age_assignment.child }}
            <template #icon><ChildIcon aria-hidden="true" /></template>
          </HMChip>
        </HMChipList>
        <div v-if="room.short_room.accomodation_type.pax > 1" class="hm-dashboard__content-guest">
              <span class="hm-dashboard__gender">
                <MaleIcon v-if="room.guests[1]?.gender && room.guests[1]?.gender.code === 'male'"/>
                <FemaleIcon v-else-if="room.guests[1]?.gender && room.guests[1]?.gender.code === 'female'"/>
              </span>
          <span
            v-if="room.guests[1]"
            :class="{ 'hm-dashboard__flag--empty': !(room.guests[1]?.citizenship && room.guests[1]?.citizenship.code) }"
            :title="room.guests[1]?.citizenship && room.guests[1]?.citizenship.name ? room.guests[1]?.citizenship.name : ''"
            class="hm-dashboard__flag"
          >
                <span
                  v-if="room.guests[1]?.citizenship && room.guests[1]?.citizenship.code"
                  :class="`fflag ff-md fflag-${room.guests[1]?.citizenship.code}`"
                ></span>
              </span>
          <button v-else class="hm-dashboard__add-guest">
            <PlusSmallGreen/>
          </button>
          <span :class="{'hm-dashboard__guest-name--unknown': !room.guests[1]}" class="hm-dashboard__guest-name">
                <span v-if="room.guests[1]" class="hm-dashboard__highlighted">
                  {{
                    (
                      room.guests[1]?.gender && room.guests[1]?.gender.greeting
                    ) ? room.guests[1]?.gender.greeting : ''
                  }} {{
                    room.guests[1]?.full_name || (
                      (
                        room.guests[1]?.first_name || ''
                      ) + ' ' + (
                        room.guests[1]?.last_name || ''
                      )
                    )
                  }}
                </span>
                <span v-else>Guest #2 - Unknown</span>
              </span>
        </div>
      </div>
      <div v-if="room.short_room.accomodation_type.pax > 2" class="hm-dashboard__grid">
        <span></span>
        <span></span>
        <span></span>
        <div class="hm-dashboard__content-guest">
              <span class="hm-dashboard__gender">
                <MaleIcon v-if="room.guests[2]?.gender && room.guests[2]?.gender.code === 'male'"/>
                <FemaleIcon v-else-if="room.guests[2]?.gender && room.guests[2]?.gender.code === 'female'"/>
              </span>
          <span
            v-if="room.guests[2]"
            :class="{ 'hm-dashboard__flag--empty': !(room.guests[2]?.citizenship && room.guests[2]?.citizenship.code) }"
            :title="room.guests[2]?.citizenship && room.guests[2]?.citizenship.name ? room.guests[2]?.citizenship.name : ''"
            class="hm-dashboard__flag"
          >
                <span
                  v-if="room.guests[2]?.citizenship && room.guests[2]?.citizenship.code"
                  :class="`fflag ff-md fflag-${room.guests[2]?.citizenship.code}`"
                ></span>
              </span>
          <button v-else class="hm-dashboard__add-guest">
            <PlusSmallGreen/>
          </button>
          <span :class="{'hm-dashboard__guest-name--unknown': !room.guests[2]}" class="hm-dashboard__guest-name">
                <span v-if="room.guests[2]" class="hm-dashboard__highlighted">
                  {{
                    (
                      room.guests[2]?.gender && room.guests[2]?.gender.greeting
                    ) ? room.guests[2]?.gender.greeting : ''
                  }} {{
                    room.guests[2]?.full_name || (
                      (
                        room.guests[2]?.first_name || ''
                      ) + ' ' + (
                        room.guests[2]?.last_name || ''
                      )
                    )
                  }}
                </span>
                <span v-else>Guest #3 - Unknown</span>
          </span>
        </div>
      </div>
    </div>
    <div v-if="currentRoomsStatus !== 'in_house'" class="hm-dashboard__line-right">
      <HMButton @click.native="onShowModal" :background="textMap[currentRoomsStatus].btnBg" :color="textMap[currentRoomsStatus].btnColor">
        <component :is="textMap[currentRoomsStatus].icon" aria-hidden="true"/>
        <span>{{ textMap[currentRoomsStatus].btnText }}</span>
      </HMButton>
    </div>

  </div>
</template>

<script>
// import DirtyIcon from '@/views/hotel-management/reservations/detail/icons/DirtyIcon.vue'
import AdultIcon from '@/views/hotel-management/reservations/detail/icons/AdultIcon.vue'
import PlusSmallGreen from '@/views/hotel-management/reservations/detail/icons/PlusSmallGreen.vue'
import InfoEmptyIcon from '@/views/hotel-management/reservations/detail/icons/InfoEmptyIcon.vue'
import ChildIcon from '@/views/hotel-management/reservations/detail/icons/ChildIcon.vue'
import NightsIcon from '@/views/hotel-management/reservations/detail/icons/NightsIcon.vue'
import TeenagerIcon from '@/views/hotel-management/reservations/detail/icons/TeenagerIcon.vue'
import CalendarIcon from '@/views/hotel-management/reservations/detail/icons/CalendarIcon.vue'
import ArrowIcon from '@/views/hotel-management/reservations/detail/icons/ArrowIcon.vue'
import MaleIcon from '@/views/hotel-management/reservations/detail/icons/MaleIcon.vue'
import FemaleIcon from '@/views/hotel-management/reservations/detail/icons/FemaleIcon.vue'
import CheckInBtn from '@/views/hotel-management/reservations/detail/icons/CheckInBtn.vue'
import CheckOutBtn from '@/views/hotel-management/reservations/detail/icons/CheckOutBtn.vue'
import HMChipList from '@/views/hotel-management/reservations/components/HMChipList.vue'
import HMChip from '@/views/hotel-management/reservations/components/HMChip.vue'
import HMBalance from '@/views/hotel-management/reservations/components/HMBalance.vue'
import HMTooltip from '@/views/hotel-management/reservations/components/HMTooltip.vue'
import HMButton from '@/views/hotel-management/reservations/components/HMButton.vue'
import HMRoomsItem from '@/views/hotel-management/reservations/components/HMRoomsItem.vue'

export default {
  name: 'HMDashboardLine',
  components: {
    HMRoomsItem,
    HMButton,
    HMTooltip,
    HMBalance,
    HMChipList,
    HMChip,
    FemaleIcon,
    MaleIcon,
    ArrowIcon,
    CalendarIcon,
    TeenagerIcon,
    NightsIcon,
    ChildIcon,
    InfoEmptyIcon,
    PlusSmallGreen,
    AdultIcon,
    CheckInBtn,
    CheckOutBtn
    // DirtyIcon,
  },
  props: {
    room: Object,
    currentRoomsStatus: String,
    query: String,
  },
  data() {
    return {
      textMap: {
        check_in_today: {
          btnText: 'Check In',
          btnBg: 'linear-gradient(180deg, #E3E8D9 0%, #DCE4CD 100%)',
          btnColor: '#698262',
          icon: CheckInBtn,
        },
        check_out_today: {
          btnText: 'Check Out',
          btnBg: 'linear-gradient(0deg, #FFCDB5 0%, #FBE0D2 100%)',
          btnColor: '#A4744A',
          icon: CheckOutBtn,
        },
      }
    }
  },
  methods: {
    onShowModal() {
      this.$emit('onShowModal', this.room)
    },
    fmtShortDate(iso) {
      if (!iso) return ''
      const d = new Date(`${ iso }T00:00:00`)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${ d.getDate() } ${ months[d.getMonth()] }`
    },
  },
}
</script>

<style>
.hm-dashboard__row {
  padding: 20px 0;
  margin-bottom: 10px;
  border-radius: 16px;
  border: 1px solid #E9E9E9;
  background-color: #FFF;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
}

.hm-dashboard__grid-name {
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  transition: color 0.3s;

  &:hover {
    color: #468832;
  }
}

.hm-dashboard__grid-number {
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: normal;
}

.hm-dashboard__grid-holder {
  display: flex;
  align-items: center;
  gap: 10px
}

.hm-dashboard__grid-holder--between {
  justify-content: space-between;
}

.hm-dashboard__grid-room {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 8px;
  border-radius: 19px;
  background: #FFF;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.13);
  color: #9B593A;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 13px;
  font-weight: 500;
}

.hm-dashboard__grid-room--clean {
  color: #76A9B4;
}

.hm-dashboard__grid-info {
  color: #666;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.48px;
  text-transform: uppercase;
}

.hm-dashboard__dates {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  line-height: 1;
  font-weight: 500;
}

.hm-dashboard__gender {
  width: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.hm-dashboard__flag {
  flex-shrink: 0;
  width: 19px;
  height: 19px;
  border-radius: 50%;
  border: 1px solid #b5b5b5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background: #fff;
  overflow: hidden;
}

.hm-dashboard__flag--empty {
  background: #efefef;
  border-color: #efefef;
}

.hm-dashboard__guest-name {
  color: #000;
  font-size: 15px;
  font-family: 'CoreSansCR', sans-serif;
  font-weight: 500;
}

.hm-dashboard__guest-name--unknown {
  color: #DA8C7B;
}

.hm-dashboard__content-guest {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.hm-dashboard__content-guest--mb {
  display: flex;
  margin-bottom: 15px;
}

.hm-dashboard__add-guest {
  line-height: 0;
}

.hm-dashboard__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  min-width: 130px;
  padding: 5px 12px;
  border-radius: 8px;
  background: linear-gradient(180deg, #E3E8D9 0%, #DCE4CD 100%);
  color: #698262;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 500;
  transition: filter 0.3s;
}

.hm-dashboard__button:hover {
  filter: brightness(0.95);
}
</style>

